import InputField from "../../../../components/generic/inputField";
import React, { useState } from "react";
import { Row } from "react-bootstrap";
import EdButton from "../../../../components/generic/edbutton/edButton";
import { alphabetExp, phoneNo } from "../../../../utils/regex";
import india from "../../../../assets/images/generic/India.svg";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
export const inputfield = {
    name: "",
    mobile: "",
    email: "",
};
export const numberPrefix = () => (React.createElement(React.Fragment, null,
    React.createElement("img", { src: india }),
    " +91"));
const RegisterPage = (props) => {
    const exceptThisSymbols = ["e", "E", "+", "-", "."];
    const [formData, setFormData] = useState(inputfield);
    const [error, setError] = useState(inputfield);
    const [errorState, setErrorState] = useState(false);
    const DisableGotoNext = () => {
        let disable = false;
        if (!props.removeMobNumField && !props.removeNameField) {
            return (error.name.length > 0 ||
                error.mobile.length > 0 ||
                formData.name.length <= 0 ||
                formData.mobile.length != 10);
        }
        props.removeNameField &&
            (error.mobile.length > 0 || formData.mobile.length < 10)
            ? (disable = true)
            : null;
        props.removeMobNumField &&
            (error.name.length > 0 || formData.name.length < 3)
            ? (disable = true)
            : null;
        return disable || (props === null || props === void 0 ? void 0 : props.disableSubmit) || props.loginButtonDisable;
    };
    const handleChange = (event) => {
        setFormData(Object.assign(Object.assign({}, formData), { [event.target.name]: event.target.value }));
        if (props.loginButtonDisable)
            props.setLoginDisable(false);
        for (let [key, val] of Object.entries(error)) {
            if (val === "")
                continue;
            setError(Object.assign(Object.assign({}, error), { [key]: inputfield[key] }));
        }
    };
    const validationError = (field, value) => {
        setError(Object.assign(Object.assign({}, error), { [field]: value }));
    };
    React.useEffect(() => {
        props.parentStateVariable && props.parentStateVariable(formData);
    }, [formData]);
    React.useEffect(() => {
        if (errorState && formData.mobile.length != 10) {
            setErrorState(false);
        }
    }, [errorState, formData]);
    return (React.createElement("div", { className: `register-page-block ${props.className}` },
        React.createElement(Row, { className: "DMSansBold_20_700 txt-midnight-blue m-0 pb-30" }, !DeviceContext().isDesktop && props.pageTitle && props.pageTitle),
        React.createElement("form", { id: "register-form", onSubmit: (e) => {
                e.preventDefault(), e.stopPropagation();
            } },
            props.removeNameField ? (React.createElement(React.Fragment, null)) : (React.createElement(Row, { className: "register-inputfield mt-5" },
                React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), defaultValue: formData.name, pattern: alphabetExp, onBlur: (error, event) => {
                        if (error.required)
                            validationError(event.target.name, "This field is Required");
                        else if (error.minLength) {
                            validationError(event.target.name, "Please enter at least 3 characters");
                        }
                        else if (!error.pattern)
                            validationError(event.target.name, "Only alphabets are allowed");
                        else
                            validationError(event.target.name, "");
                    }, errorText: error.name, highlightInputField: true, placeholder: "Enter your name", id: "name", name: "name", type: "text", autoComplete: "off", showLabel: true, placeholderClassName: "floating-label ", className: "custom-form-control", required: true, maxLength: 50, minLength: 3, autofocus: !(props === null || props === void 0 ? void 0 : props.removeNameField) ? true : false }))),
            props.removeMobNumField ? (React.createElement(React.Fragment, null)) : (React.createElement(Row, { className: "register-inputfield input-group register-inputfiled-mob mt-5 m-0" },
                React.createElement(InputField, { onKeyDown: (e) => exceptThisSymbols.includes(e.key) && e.preventDefault(), onChangeEvent: (e) => handleChange(e), pattern: phoneNo, onBlur: (error, event) => {
                        if (error.required)
                            validationError(event.target.name, "This field is Required");
                        else if (!error.pattern)
                            validationError(event.target.name, "Invalid mobile number");
                        else
                            validationError(event.target.name, "");
                    }, errorText: error.mobile, highlightInputField: true, defaultValue: formData.mobile, placeholder: "Enter your mobile number", id: "mobile", name: "mobile", type: "number", maxLength: 10, autoComplete: "off", showLabel: true, prefix: numberPrefix(), placeholderClassName: "floating-label ", className: "custom-form-control", required: true, autofocus: (props === null || props === void 0 ? void 0 : props.removeNameField) ? true : false }))),
            errorState && (props === null || props === void 0 ? void 0 : props.errorState),
            React.createElement(Row, { className: "m-0 mt-5" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Next", type: "submit", onClick: () => (props.submit(), setErrorState(true)), disabled: DisableGotoNext() })))));
};
export default RegisterPage;
